import {PreviewMainProgram} from "features/preview-main-program";

export const PreviewMainProgramPage = () => {
  return <PreviewMainProgram/>;
};

